module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADlSURBVFiF7ZdLCsIwEEDf1It4E9teoTuP4kJbQT2I6LJHaHMy60ZpQQVJJoXQecvADA+SzAcMwzCMRSC+gfXlmsuQ9YK4/W5baEp9I/MNlEeWAwwM+fF877WEfuEtOmUOWe+rB2hOtxrhMCaL9wyCRGE+2WBRmEdWRRTiy6qJQlxZVVGIJ6suCnFko4iCvuxKR+sT17WuKCtByF9H66KsxHWt88mn0pn+RUQ23rGaIlO0r365nymJ8pREwU+ihSYxlCQx5iUxOL+XuzFR3CUveLmD+JIQ2EIFcQw0c6zLhmEYxkJ4AjPQdkvA9jcOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/chevron-down@3x.png
// module id = RZ9A
// module chunks = 3